import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import classnames from 'classnames';
import { compose, withHandlers, defaultProps } from 'recompose';
import Checkmark from 'components/svg/Checkmark';
import { withClickTracking } from 'components/core/library/tracking-utils';

import './checkbox.scss';

export const enhance = compose(
	defaultProps({
		input: { onChange: noop }
	}),
	// TODO: Refactor withClickTracking/destructure props without HOC
	withClickTracking,
	withHandlers({
		onCheckboxClick: ({ handleClick, input: { value, onChange } }) => (e) => {
			handleClick(e);
			onChange(!value);
		}
	})
);

export function Checkbox({
	id, onCheckboxClick, name, label, input: { value }, disabled = false
}) {
	return (
		<div className="ph-checkbox">
			<label className="checkbox-label" htmlFor={id}>
				<span className={classnames('checkbox', { checked: !!value })}>
					{!!value && <Checkmark />}
				</span>
				<input
					type="checkbox"
					id={id}
					name={name}
					value={value}
					onChange={onCheckboxClick}
					disabled={disabled}
				/>
				{label}
			</label>
		</div>
	);
}

Checkbox.propTypes = {
	onCheckboxClick: PropTypes.func,
	id: PropTypes.string.isRequired,
	name: PropTypes.string,
	label: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node
	]),
	input: PropTypes.shape({ value: PropTypes.any, onChange: PropTypes.func }),
	disabled: PropTypes.bool
};

export default enhance(Checkbox);
